import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { isNotOnPublicPage } from '@/utils/http';

const DEFAULT_UI_VERSION = 'current';
const NEW_UI_VERSION = 'new';
const uiVersion = ref(DEFAULT_UI_VERSION);

export default function useUiVersion () {
    const route = useRoute();

    const setUiVersion = (value) => {
        const updatedVersion = value ? NEW_UI_VERSION : DEFAULT_UI_VERSION;

        window.localStorage.setItem('pendo-ui-version', updatedVersion);
        uiVersion.value = updatedVersion;

        if (updatedVersion === NEW_UI_VERSION) {
            document.documentElement.setAttribute('data-ui', NEW_UI_VERSION);
        } else {
            document.documentElement.removeAttribute('data-ui');
        }
    };

    const initializeUiVersion = () => {
        const setupUiVersion = () => {
            uiVersion.value = window.localStorage.getItem('pendo-ui-version') || DEFAULT_UI_VERSION;

            if (uiVersion.value === NEW_UI_VERSION) {
                document.documentElement.setAttribute('data-ui', NEW_UI_VERSION);
            } else {
                document.documentElement.removeAttribute('data-ui');
            }
        };

        if (isNotOnPublicPage()) {
            setupUiVersion();
        } else {
            const unwatch = watch(() => route.path, (newPath) => {
                if (newPath && isNotOnPublicPage()) {
                    unwatch();
                    setupUiVersion();
                }
            });
        }
    };

    const isNewUi = computed(() => {
        return uiVersion.value === NEW_UI_VERSION;
    });

    return {
        isNewUi,
        setUiVersion,
        initializeUiVersion,
    };
}